import { render, staticRenderFns } from "./Vuex.vue?vue&type=template&id=4f80e3d8&scoped=true&"
import script from "./Vuex.vue?vue&type=script&lang=js&"
export * from "./Vuex.vue?vue&type=script&lang=js&"
import style0 from "./Vuex.vue?vue&type=style&index=0&id=4f80e3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80e3d8",
  null
  
)

export default component.exports